import { createRequestActionTypes } from "../../shared/utility";

export const ClientLogAction = {
    fetchLogLevel: createRequestActionTypes('FETCH_LOG_LEVEL'),
    addOrEditClientLog: createRequestActionTypes('ADD_EDIT_CLIENT_LOG'),
    fetchDirectoryPath: createRequestActionTypes('FETCH_DIRECTORY_PATH'),
    fetchClientLogDetails: createRequestActionTypes('FETCH_CLIENT_LOG_DETAILS'),
}